import React from 'react';
import { Box, Typography } from '@mui/material';

const Topology: React.FC = () => (
  <Box sx={{ color: '#fff', p: 4 }}>
    <Typography variant="h4">Topology</Typography>
    <Typography sx={{ mt: 2 }}>Topology page (stub)</Typography>
  </Box>
);

export default Topology;
